import { Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { ServicesStatusesDialogComponent } from '../../components/dialogs/services-statuses-dialog/services-statuses-dialog.component';
import { ServicesCategoriesDialogComponent } from '../../components/dialogs/services-categories-dialog/services-categories-dialog.component';

@Component({
    selector: 'app-services-state-list',
    templateUrl: './services-state-list.component.html',
    styleUrls: ['./services-state-list.component.scss'],
})
export class ServicesStateListComponent implements OnDestroy {
    destroy$ = new Subject();

    loading = false;

    constructor(private dialog: MatDialog) {}

    openEditStatusesDialog() {
        const dialogRef = this.dialog.open(ServicesStatusesDialogComponent, {
            panelClass: 'service-status-dialog',
            autoFocus: false,
        });
    }

    openEditCategoriesDialog() {
        this.dialog.open(ServicesCategoriesDialogComponent, {
            panelClass: 'services-categories-dialog',
            autoFocus: false,
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
